import { Exclude, Expose } from "class-transformer";
import { IsString, IsDefined } from "class-validator";

import { GObjectType, GInputType, GField } from "../graphql";

import { AutomaticEmailBase } from "./AutomaticEmailBase";

@GObjectType("AutomaticEmailEvent")
@GInputType("AutomaticEmailEventInput")
@Exclude()
export class AutomaticEmailEvent extends AutomaticEmailBase {
    @GField()
    @IsString()
    @IsDefined()
    @Expose()
    public recipient: string;
}
